import { useApiQuery } from './useApiQuery';
import { projectsApi } from '../lib/api/projects';
import type { ProjectSummary } from '@overlayqa/shared';
import { log } from '@/lib/logger';

log.info('[useProjectSummary] Module loaded');

export function useProjectSummary(projectId: string) {
  log.info('[useProjectSummary] hook called, projectId:', { projectId });

  return useApiQuery<ProjectSummary>({
    queryKey: ['project-summary', projectId],
    queryFn: (token) => projectsApi.getSummary(token, projectId),
    staleTime: 60_000,
    enabled: !!projectId,
  });
}
